/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const EyeLight = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 9.41667C8.4715 9.41667 8.92368 9.22351 9.25708 8.8797C9.59048 8.53588 9.77778 8.06956 9.77778 7.58333C9.77778 7.0971 9.59048 6.63079 9.25708 6.28697C8.92368 5.94315 8.4715 5.75 8 5.75C7.97222 5.75 7.94778 5.75687 7.92083 5.75831C8.0065 6.0016 8.0231 6.26505 7.96868 6.51773C7.91427 6.77041 7.79109 7.00184 7.61361 7.18487C7.43613 7.3679 7.21171 7.49492 6.96668 7.55104C6.72166 7.60716 6.4662 7.59004 6.23027 7.50169C6.23027 7.53034 6.22222 7.55555 6.22222 7.58333C6.22222 7.82409 6.2682 8.06249 6.35754 8.28492C6.44689 8.50735 6.57784 8.70946 6.74292 8.8797C7.07632 9.22351 7.5285 9.41667 8 9.41667ZM15.9033 8.08177C14.397 5.05076 11.4147 3 8 3C4.58527 3 1.60221 5.05219 0.0966517 8.08206C0.0331076 8.21168 0 8.3549 0 8.50014C0 8.64539 0.0331076 8.7886 0.0966517 8.91823C1.60304 11.9492 4.58527 14 8 14C11.4147 14 14.3978 11.9478 15.9033 8.91794C15.9669 8.78832 16 8.6451 16 8.49986C16 8.35461 15.9669 8.2114 15.9033 8.08177ZM8 3.91667C8.70322 3.91667 9.39065 4.13171 9.97536 4.53461C10.5601 4.93751 11.0158 5.51017 11.2849 6.18016C11.554 6.85016 11.6244 7.5874 11.4872 8.29866C11.3501 9.00993 11.0114 9.66327 10.5142 10.1761C10.0169 10.6889 9.38337 11.0381 8.69366 11.1795C8.00394 11.321 7.28904 11.2484 6.63935 10.9709C5.98965 10.6934 5.43435 10.2234 5.04366 9.62042C4.65297 9.01744 4.44444 8.30853 4.44444 7.58333C4.44547 6.6112 4.8204 5.67918 5.48697 4.99178C6.15355 4.30438 7.05732 3.91773 8 3.91667ZM8 13.0833C5.01777 13.0833 2.29277 11.3271 0.888875 8.5C1.67844 6.90154 2.94112 5.60392 4.49388 4.79523C3.91416 5.56924 3.55555 6.52831 3.55555 7.58333C3.55555 8.79891 4.0238 9.9647 4.8573 10.8242C5.69079 11.6838 6.82126 12.1667 8 12.1667C9.17874 12.1667 10.3092 11.6838 11.1427 10.8242C11.9762 9.9647 12.4445 8.79891 12.4445 7.58333C12.4445 6.52831 12.0858 5.56924 11.5061 4.79523C13.0589 5.60392 14.3216 6.90154 15.1111 8.5C13.7075 11.3271 10.9822 13.0833 8 13.0833Z"
        fill={color}
      />
    </svg>
  );
};
